module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/patient_recommends/img_avatar_10-8a56a4e402f7748102aeaaf0b33cdf09.png";